<template>
    <div class="font-16">
        {{ categoryModel.name }}
        <hr class="mb-1">
    </div>
</template>

<script>
import {AutomationTypes} from '@/types/automations/types'

export default {
    name: 'AutomationTemplateGroupHeader',
    inject: ['getAvailableCategories'],
    props: {
        uuid: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        }
    },
    computed: {
        categoryModel() {
            return this.getAvailableCategories({type: this.type}).find(c => c.uuid === this.uuid) || {}
        }
    }
}
</script>
